document.addEventListener("DOMContentLoaded", function () {
  const galeryImages = Array.from(
    document.querySelectorAll(".swiper-galery .swiper-slide img")
  );
  if (!galeryImages.length) return;

  galeryImages.forEach((img, idx) => {
    img.style.cursor = "zoom-in";
    img.addEventListener("click", function (e) {
      e.preventDefault();
      showLightbox(idx);
    });
  });

  function showLightbox(startIndex) {
    let currentIndex = startIndex;
    const overlay = document.createElement("div");
    overlay.className = "pluri-lightbox-overlay";
    overlay.innerHTML = `
        <button class="pluri-lightbox-nav pluri-lightbox-prev" aria-label="Anterior">&#10094;</button>
        <div class="pluri-lightbox-content">
          <button class="pluri-lightbox-close" aria-label="Cerrar">&times;</button>
          <img src="" alt="">
        </div>
        <button class="pluri-lightbox-nav pluri-lightbox-next" aria-label="Siguiente">&#10095;</button>
      `;
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    const imgTag = overlay.querySelector("img");
    const prevBtn = overlay.querySelector(".pluri-lightbox-prev");
    const nextBtn = overlay.querySelector(".pluri-lightbox-next");
    const closeBtn = overlay.querySelector(".pluri-lightbox-close");

    function updateImage() {
      const img = galeryImages[currentIndex];
      imgTag.src = img.src;
      imgTag.alt = img.alt || "";
    }
    updateImage();

    function showPrev() {
      currentIndex =
        (currentIndex - 1 + galeryImages.length) % galeryImages.length;
      updateImage();
    }
    function showNext() {
      currentIndex = (currentIndex + 1) % galeryImages.length;
      updateImage();
    }

    prevBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      showPrev();
    });
    nextBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      showNext();
    });
    closeBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      closeLightbox();
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) {
        closeLightbox();
      }
    });

    // Navegación con teclado
    function keyHandler(e) {
      if (e.key === "Escape") {
        closeLightbox();
      } else if (e.key === "ArrowLeft") {
        showPrev();
      } else if (e.key === "ArrowRight") {
        showNext();
      }
    }
    document.addEventListener("keydown", keyHandler);

    function closeLightbox() {
      overlay.remove();
      document.body.style.overflow = "";
      document.removeEventListener("keydown", keyHandler);
    }
  }
});
